import { Box } from '@mui/material';
import { DAY_LABELS } from './constants';

const DaysChips = ({ daysOfOperation = '' }) => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Box 
      display="flex" 
      flexWrap="nowrap"
      gap={0.25} 
    >
      {[1, 2, 3, 4, 5, 6, 7].map((d) => {
        const active = daysOfOperation.includes(String(d));

        return (
          <Box 
            key={d} 
            sx={{
              width: 17, 
              height: 17, 
              borderRadius: 1,
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              bgcolor: active ? (d <= 5 ? 'primary.main' : 'warning.main') : 'action.disabledBackground',
              fontSize: '0.5rem', 
              color: active ? '#fff' : 'text.disabled',
              fontFamily: 'monospace', 
              fontWeight: active ? 'bold' : 'normal',
            }}
          >
            {DAY_LABELS[d][0]}
          </Box>
        );
      })}
    </Box>
  </Box>
);

export default DaysChips;
